import TaskManagerPage from "./app/pages/TaskManagerPage";

export default function App() {
  return (
    <TaskManagerPage />
  );
}